var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sa-video" },
    [
      _c("top-video", {
        attrs: { url: _vm.url, "cover-img": _vm.coverImg },
        on: {
          "img-loaded": function ($event) {
            return _vm.imgLoaded()
          },
        },
      }),
      _vm._v(" "),
      _vm.afterImgLoad
        ? _c("div", { staticClass: "vrResult" }, [
            _c("div", { staticClass: "sa-video-tit" }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sa-video-info" }, [
              _c("span", [_vm._v(_vm._s(_vm.nickName))]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.publishTime))]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }